import React from 'react';

const ReportSummaryContext = React.createContext({});
ReportSummaryContext.displayName = 'ReportSummaryContext';

export default ReportSummaryContext;
